import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
	RHookFormDatePicker,
} from "@websential/cosmic-v20";
import { Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

interface IWSIBReportHeader {
	setStateRunGetListAPICall: (value: boolean) => void
	departmentsDDL: any;
	yearDDLItems: any;
	taxYear: any;
}

export const WSIBReportHeader: React.FC<
	IWSIBReportHeader
> = ({ departmentsDDL, setStateRunGetListAPICall, yearDDLItems, taxYear }) => {

	return (
		<>
			<Grid
				container
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				sx={{
					background: "#fff",
					border: "1px solid #e5e7eb",
					borderBottom: 0,
					borderRadius: "2px 2px 0 0",
					padding: "3rem 0px 0.8rem 0.8rem",
				}} columnSpacing={2}>
				<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
					<EnhancedDropDownRHFWithLabel
						selectName={"selectedYear"}
						items={yearDDLItems ?? []}
						label={"Selected Year"}
						// selectedItem={yearDDLItems && yearDDLItems.find((item: any) => item.label === taxYear).value}
						// selectedItem={
						// 	yearDDLItems && yearDDLItems.length > 0
						// 		? yearDDLItems.find((item: any) => Number(item.label) === Number(taxYear))?.value ?? ""
						// 		: ""
						// }

						testId={"selected=year-ddl"}
						onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
						showEmpty
					/>
				</Grid>
				<Grid
					size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
					sx={{
						color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem",
						"& .MuiGrid-root": {},
					}}>
					<EnhancedDropDownRHFWithLabel
						selectName={"groupBy"}
						items={[
							{
								label: "WSIB Code",
								value: 200,
							},
							{
								label: "Employee",
								value: 100,
							},
						]}
						label={"Group By"}
						testId={"group-by"}
						// selectedItem={"all"}
						selectedItem={100}
					// onSelectionChangeHandler={onEmployeeStatusSelectionChangeHandler}
					/>
				</Grid>
				<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
					<EnhancedDropDownRHFWithLabel
						selectName={"department"}
						items={departmentsDDL ?? []}
						selectedItem={"all"}
						label={"Department"}
						testId={"department-ddl"}
						onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
					/>
				</Grid>

				<Grid
					size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5, xl: 2.5 }}
				>
					<RHookFormDatePicker
						name="startDate"
						testId="start-date"
						label="Date In"
						format="M dd, yy"
					/>
				</Grid>
				<Grid
					size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5, xl: 2.5 }}
					sx={{
						"& .MuiGrid-root .MuiFormLabel-root": { marginTop: "24px!important", },
						// "& .calenderWrapper ": { maxWidth: "130px!important"},
					}}
				>
					<RHookFormDatePicker
						name="endDate"
						testId="end-date"
						label=""
						format="M dd, yy"
					/>
				</Grid>
				<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
					<EnhancedButtonPrimeReact
						label="Apply Filter"
						raised
						type="submit"
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
					// onClickHandler={() => setStateRunGetListAPICall(true)}
					/>

				</Grid>

				{/* </Grid> */}
			</Grid>

		</>
	);
};
